import React from 'react';
import { CollectionPreferences, CollectionPreferencesProps } from '@amzn/awsui-components-react';
import { TablePreferences } from './types';
import { PAGE_SIZE_OPTIONS } from './constants';

export const Preferences: React.FC<{
  preferences: TablePreferences;
  setPreferences: (preferences: TablePreferences) => void;
  disabled: boolean;
  pageSizeOptions?: typeof PAGE_SIZE_OPTIONS;
  visibleContentOptions: { label: string; options: { id: string; label: string; }[] }[];
}> = ({
  preferences,
  setPreferences,
  disabled,
  pageSizeOptions = PAGE_SIZE_OPTIONS,
  visibleContentOptions
}) => (
  <CollectionPreferences
    title="Preferences"
    confirmLabel="Confirm"
    cancelLabel="Cancel"
    disabled={disabled}
    preferences={preferences}
    onConfirm={({ detail }: { detail: CollectionPreferencesProps.Preferences }) => {
      const updatedPreferences: TablePreferences = {
        pageSize: detail.pageSize || preferences.pageSize,
        visibleContent: detail.visibleContent || preferences.visibleContent,
        wrapLines: detail.wrapLines ?? preferences.wrapLines,
      };
      setPreferences(updatedPreferences);
    }}
    pageSizePreference={{
      title: 'Page size',
      options: pageSizeOptions,
    }}
    wrapLinesPreference={{
      label: 'Wrap lines',
      description: 'Check to see all the text and wrap the lines',
    }}
    visibleContentPreference={{
      title: 'Select visible columns',
      options: visibleContentOptions,
    }}
  />
);